'use strict';

angular.module('supervisorAccessReviewControllers')

    .controller('SideBar_SystemToReviewCtrl', ['$scope', '$rootScope', '$timeout', 'authUser', 'systemsToReview', function ($scope, $rootScope, $timeout, authUser, systemsToReview) {
        $scope.sysRolesToReviewBySystem = _.groupBy(systemsToReview, function (s) { return s.BusinessSystem.SystemID; });
        
    $scope.systemsToReview = _.chain(systemsToReview)
                              .groupBy(function (s) { return s.BusinessSystem.SystemID; })
                              .map(function (value, key) { return value[0].BusinessSystem; })
                              .sortBy(function (s) { return s.Name; })
                              .value();

    var idxSystem = -1;
    _.each($scope.systemsToReview, function (data, idx) {
        if (_.isEqual(data.SystemID, $scope.systemID)) {
            idxSystem = idx;
            return;
        }
    });
    $scope.systemsToReview.activeSystemIndex = idxSystem;

    $scope.$on('$viewContentLoaded', function () {
            $timeout(function () {
                var topDiv = document.getElementById("systemScroll").getBoundingClientRect().top;
                var topElem = document.getElementById("scrollTo").getBoundingClientRect().top;
                
                document.getElementById("systemScroll").scrollTop = topElem - topDiv - 200;
            }, 0);
    });
      
    $scope.$on('newReviewSystem', function () {
        var confirmedSystemRole = _.filter($scope.sysRolesToReviewBySystem[$scope.$parent.systemID], function (s) {
            return s.SystemRole.SystemRoleID == $scope.$parent.systemRoleID;
        })[0];

        confirmedSystemRole.AccessReviewID = $scope.$parent.accessReview.AccessReviewID;
    });

    $scope.isCompleteSystem = function (systemToReview) {
        var sysRolesToReview = $scope.sysRolesToReviewBySystem[systemToReview.SystemID];
        var notCompletedSysRoles = _.filter(sysRolesToReview, function (s) { return _.isUndefined(s.AccessReviewID); });
        return notCompletedSysRoles.length === 0;
    };

    $scope.isCompleteSystemRole = function (sysRoleToReview) {
        return !_.isUndefined(sysRoleToReview.AccessReviewID); 
    };

    $scope.isSystemRoleActive = function (systemRole) {
        if (_.isUndefined(systemRole)) return false;
        return systemRole.SystemRoleID === $scope.systemRoleID;
        };

    $scope.getSystemCssIcon = function (businessSystem) {
        var systemCssIcon = businessSystem.SystemCssIcon;

        if (_.isUndefined(systemCssIcon) || _.isEmpty(systemCssIcon)) {
            systemCssIcon = 'fa fa-laptop';
        }

        return systemCssIcon;
    };
}]);